module.exports = __webpack_public_path__ + "assets/img/33_8_big.9b2fb1fa.jpg";